// @flow

import * as React from 'react';
import './Title.scss';

type TitleProps = {|
  children: React.Node,
|};

export const Title = ({children}: TitleProps) => (
  <h1 className="Title">{children}</h1>
);
